import { render, staticRenderFns } from "./AppQrLanding.vue?vue&type=template&id=073c775d&"
import script from "./AppQrLanding.vue?vue&type=script&lang=js&"
export * from "./AppQrLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports